import { Pagination } from './commonTypes';

export enum WorkshopTaskStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  DONE = 'DONE',
  IN_CITY = 'IN_CITY',
}

export interface WorkshopTaskScooter {
  _id: string;
  name: string;
  flespiTypeId: string;
  battery: number;
  coords: {
    lat: number;
    lon: number;
  };
  model: string;
}

export interface WorkshopTaskEmployee {
  _id: string;
  login: string;
  firstName: string;
  lastName: string;
}

export interface WorkshopTaskSparePart {
  _id: string;
  id: {
    _id: string;
    name: string;
  };
  qty: number;
}

export interface WorkshopTask {
  _id: string;
  scooter: WorkshopTaskScooter | string;
  status: WorkshopTaskStatus;
  description: string;
  estimateMinutes: number;
  employee?: WorkshopTaskEmployee | string;
  city: string;
  spareParts: WorkshopTaskSparePart[];
  photos: string[];
  createdAt: string;
  updatedAt: string;
  startAt?: string;
  factMinutes?: number;
  finishedAt?: string;
  note?: string;
  price?: number;
}

export interface CreateWorkshopTaskBody {
  scooterName: string;
  description: string;
  estimateMinutes?: number;
  employee?: string;
}

export interface UpdateWorkshopTaskBody {
  description?: string;
  estimateMinutes?: number;
  status?: WorkshopTaskStatus;
  employee?: string;
}

export interface FinishWorkshopTaskBody {
  factMinutes?: number;
  spareParts?: Array<{
    id: string;
    qty: number;
    warehouseId: string;
  }>;
  photos?: string[];
  price?: number;
  note?: string;
}

export interface GetWorkshopTasksParams {
  status?: WorkshopTaskStatus;
  employee?: string;
  description?: string;
  scooterName?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
}

export interface GetWorkshopTasksResponse {
  data: WorkshopTask[];
  pagination: Pagination;
}

export interface WorkshopTaskStats {
  pending: number;
  processing: number;
  doneToday: number;
  inCity: number;
}

export interface GetWorkshopTaskStatsResponse {
  data: WorkshopTaskStats;
}
